// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LzZE","type":"styles_type__33tp0","choices":"styles_choices__3VT-J"};